import {Injectable} from "@angular/core";
import {map, Observable} from "rxjs";
import {MoovementApiClient} from "src/app/infrastructure/moovement-api/web-api/moovement.api-client";
import {AggregatedAnimalActivity} from "src/app/domain/assets/animals/aggregated-animal-activity";

interface RawAccelerationCount {
  instant: string;
  secondsSinceLastInterrupt: number;
  numberOfInterrupts: number;
}

interface RawAggregatedAnimalActivity {
  animalId: string;
  accelerationCounts: RawAccelerationCount[];
}

@Injectable({
  providedIn: 'root'
})
export class AggregatedAnimalActivityApiClient extends MoovementApiClient {



  getAggregatedAnimalActivities(animalIds: string[], start: Date): Observable<AggregatedAnimalActivity[]> {
    return this.httpClient.post<Array<RawAggregatedAnimalActivity>>(`${this.baseUrl}/api/animal/activity/aggregated/list`, { animalIds, start })
      .pipe(map(rawActivities => rawActivities.map((rawActivity: RawAggregatedAnimalActivity) => ({
        animalId: rawActivity.animalId,
        accelerationCounts: rawActivity.accelerationCounts.map((count: RawAccelerationCount) => ({
          instant: this.toDate(count.instant),
          secondsSinceLastInterrupt: count.secondsSinceLastInterrupt,
          numberOfInterrupts: count.numberOfInterrupts
        }))
      }))));
  }

  private toDate(value: string) {
    return new Date(value);
  }
}
